enum Salutation {
  DOCTOR = 'DOCTOR',
  DOCTOR_MEDICAL = 'DOCTOR_MEDICAL',
  MISS = 'MISS',
  MISSES = 'MISSES',
  MISTER = 'MISTER',
  PROFESSOR = 'PROFESSOR',
  PROFESSOR_DOCTOR = 'PROFESSOR_DOCTOR',
  PROFESSOR_DOCTOR_DOCTOR = 'PROFESSOR_DOCTOR_DOCTOR',
}

export { Salutation }
